/**
 * Master list of help articles for LearnMore dropdowns.
 *
 * Each key is a semantic ID used in templates via <LearnMoreItem id="..." />.
 * - title: Display text in the dropdown
 * - articleId: Intercom article number (for in-app display)
 * - url: Full URL (fallback when Intercom is unavailable)
 * - type: Content type — currently only "article"
 *
 * This list could also be fetched from the Intercom API eventually
 */
export const articles = {
  // ── Session Configuration ─────────────────────────────────────────
  "session-general": {
    title: "#1 General",
    articleId: 151232,
    url: "https://help.piplanning.io/en/articles/151232-1-general",
    type: "article",
  },
  "session-teams": {
    title: "#2 Teams",
    articleId: 151237,
    url: "https://help.piplanning.io/en/articles/151237-2-teams",
    type: "article",
  },
  "session-team-boards": {
    title: "#3 Team Boards",
    articleId: 151241,
    url: "https://help.piplanning.io/en/articles/151241-3-team-boards",
    type: "article",
  },
  "session-risk-board": {
    title: "#4 ART PI Risk Board",
    articleId: 151274,
    url: "https://help.piplanning.io/en/articles/151274-4-art-pi-risk-board",
    type: "article",
  },
  "session-backlog-board": {
    title: "#5 ART Backlog Board",
    articleId: 151278,
    url: "https://help.piplanning.io/en/articles/151278-5-art-backlog-board",
    type: "article",
  },
  "session-planning-board": {
    title: "#6 ART Planning Board",
    articleId: 151294,
    url: "https://help.piplanning.io/en/articles/151294-6-art-planning-board",
    type: "article",
  },
  "session-solution-planning-board": {
    title: "#7 Solution Planning Board",
    articleId: 249299,
    url: "https://help.piplanning.io/en/articles/249299-7-solution-planning-board",
    type: "article",
  },
  "session-collaboration-canvases": {
    title: "#9 Provide Collaboration Canvases",
    articleId: 240662,
    url: "https://help.piplanning.io/en/articles/240662-9-provide-collaboration-canvases",
    type: "article",
  },
  "session-status-sync-jira": {
    title: "Jira Status Sync",
    articleId: 236759,
    url: "https://help.piplanning.io/en/articles/236759-jira-status-sync",
    type: "article",
  },
  "session-status-sync-ado": {
    title: "ADO Status Sync",
    articleId: 235464,
    url: "https://help.piplanning.io/en/articles/235464-ado-status-sync",
    type: "article",
  },
  "session-status-sync-rally": {
    title: "Rally Status Sync",
    articleId: 235478,
    url: "https://help.piplanning.io/en/articles/235478-rally-status-sync",
    type: "article",
  },
  "session-backlog-sync-jira": {
    title: "ART Backlog Board Sync [with Jira]",
    articleId: 235480,
    url: "https://help.piplanning.io/en/articles/235480-art-backlog-board-sync-with-jira",
    type: "article",
  },
  "session-backlog-sync-st-jira": {
    title: "Solution Train ART Backlog Board Sync [Jira]",
    articleId: 236453,
    url: "https://help.piplanning.io/en/articles/236453-solution-train-art-backlog-board-sync-jira",
    type: "article",
  },
  "session-backlog-sync-ado": {
    title: "ADO ART Backlog Board Sync [ART]",
    articleId: 235446,
    url: "https://help.piplanning.io/en/articles/235446-ado-art-backlog-board-sync-art",
    type: "article",
  },
  "session-backlog-sync-st-ado": {
    title: "ADO ART Backlog Board Sync [ST]",
    articleId: 235456,
    url: "https://help.piplanning.io/en/articles/235456-ado-art-backlog-board-sync-st",
    type: "article",
  },
  "session-backlog-sync-rally": {
    title: "Rally Backlog Board Sync",
    articleId: 235475,
    url: "https://help.piplanning.io/en/articles/235475-rally-backlog-board-sync",
    type: "article",
  },
  "session-auto-link-dependency-chains": {
    title: "Automatically link dependency chains",
    articleId: 445475,
    url: "https://help.piplanning.io/en/articles/445475-automatically-link-dependency-chains",
    type: "article",
  },
  "session-iteration-mapping-jira": {
    title: "Jira Iteration Mapping",
    articleId: 236760,
    url: "https://help.piplanning.io/en/articles/236760-jira-iteration-mapping",
    type: "article",
  },
  "session-iteration-mapping-ado": {
    title: "ADO Iteration Sync",
    articleId: 235427,
    url: "https://help.piplanning.io/en/articles/235427-ado-iteration-sync",
    type: "article",
  },
  "session-iteration-mapping-rally": {
    title: "Rally Iteration + Planned Velocity Mapping",
    articleId: 235479,
    url: "https://help.piplanning.io/en/articles/235479-rally-iteration-planned-velocity-mapping",
    type: "article",
  },
  "session-link-sync-jira": {
    title: "Jira Link Sync",
    articleId: 115863,
    url: "https://help.piplanning.io/en/articles/115863-jira-link-sync",
    type: "article",
  },
  "session-link-sync-ado": {
    title: "ADO Link Sync",
    articleId: 235463,
    url: "https://help.piplanning.io/en/articles/235463-ado-link-sync",
    type: "article",
  },
  "session-link-sync-rally": {
    title: "Rally Link Sync",
    articleId: 235477,
    url: "https://help.piplanning.io/en/articles/235477-rally-link-sync",
    type: "article",
  },

  // ── PI Sessions Page ──────────────────────────────────────────────
  "pi-start-new-session": {
    title: "Start a new PI Session",
    articleId: 76655,
    url: "https://help.piplanning.io/en/articles/76655-start-a-new-pi-session",
    type: "article",
  },
  "pi-duplicate-session": {
    title: "Duplicate PI Session",
    articleId: 240755,
    url: "https://help.piplanning.io/en/articles/240755-duplicate-pi-session",
    type: "article",
  },
  "pi-archive-session": {
    title: "Archive a PI Session",
    articleId: 240759,
    url: "https://help.piplanning.io/en/articles/240759-archive-a-pi-session",
    type: "article",
  },
  "pi-csv-import": {
    title: "CSV Import",
    articleId: 115646,
    url: "https://help.piplanning.io/en/articles/115646-csv-import",
    type: "article",
  },
  "pi-xlsx-download": {
    title: "Export PI Session Data via XLSX Download",
    articleId: 355824,
    url: "https://help.piplanning.io/en/articles/355824-export-pi-session-data-pi-objectives-risks-dependencies-via-xlsx-download",
    type: "article",
  },

  // ── Users ─────────────────────────────────────────────────────────
  "managing-users": {
    title: "Managing Users",
    articleId: 107449,
    url: "https://help.piplanning.io/en/articles/107449-managing-users",
    type: "article",
  },
  "user-profile": {
    title: "User Profile + Login",
    articleId: 85245,
    url: "https://help.piplanning.io/en/articles/85245-user-profile-login",
    type: "article",
  },
  "alm-user-mapping": {
    title: "ALM User Mapping",
    articleId: 472551,
    url: "https://help.piplanning.io/en/articles/472551-alm-user-mapping",
    type: "article",
  },

  // ── Organization ──────────────────────────────────────────────────
  "manage-teams": {
    title: "Manage Teams",
    articleId: 108592,
    url: "https://help.piplanning.io/en/articles/108592-manage-teams",
    type: "article",
  },
  "manage-arts": {
    title: "Manage ARTs",
    articleId: 108846,
    url: "https://help.piplanning.io/en/articles/108846-manage-arts",
    type: "article",
  },
  "manage-solution-trains": {
    title: "Manage Solution Trains",
    articleId: 108847,
    url: "https://help.piplanning.io/en/articles/108847-manage-solution-trains",
    type: "article",
  },
  "manage-external-orgs": {
    title: "Manage External Orgs (External Dependencies)",
    articleId: 337167,
    url: "https://help.piplanning.io/en/articles/337167-manage-external-orgs-external-dependencies",
    type: "article",
  },

  "user-auditing": {
    title: "User Auditing and Governance",
    articleId: 206399,
    url: "https://help.piplanning.io/en/articles/206399-user-auditing-and-governance",
    type: "article",
  },

  // ── Organization ── (continued) ───────────────────────────────────
  "external-orgs-working-with": {
    title: "Working with External Orgs",
    articleId: 118662,
    url: "https://help.piplanning.io/en/articles/118662-working-with-external-orgs",
    type: "article",
  },

  // ── Settings ──────────────────────────────────────────────────────
  "company-settings": {
    title: "Company account settings & audit logs",
    articleId: 107889,
    url: "https://help.piplanning.io/en/articles/107889-company-account-settings-audit-logs",
    type: "article",
  },

  // ── ALM Connections ───────────────────────────────────────────────
  "alm-getting-started": {
    title: "ALM Connections: Getting Started",
    articleId: 74652,
    url: "https://help.piplanning.io/en/articles/74652-alm-connections-getting-started",
    type: "article",
  },
  "alm-events": {
    title: "Logs / Events on ALM connection",
    articleId: 235404,
    url: "https://help.piplanning.io/en/articles/235404-logs-events-on-alm-connection",
    type: "article",
  },
  "alm-advanced-settings": {
    title: "ALM Connection - Advanced Settings",
    articleId: 235360,
    url: "https://help.piplanning.io/en/articles/235360-alm-connection-advanced-settings",
    type: "article",
  },
  "alm-connection-failure": {
    title: "ALM Connection Failure",
    articleId: 235402,
    url: "https://help.piplanning.io/en/articles/235402-alm-connection-failure",
    type: "article",
  },
  "alm-connection-troubleshooting-jira": {
    title: "Jira Connection Troubleshooting",
    articleId: 74742,
    url: "https://help.piplanning.io/en/articles/74742-jira-connection-troubleshooting",
    type: "article",
  },
  "alm-webhook-jira": {
    title: "Adding a Webhook to Jira",
    articleId: 74980,
    url: "https://help.piplanning.io/en/articles/74980-adding-a-webhook-to-jira",
    type: "article",
  },
  "alm-webhook-jira-debug": {
    title: "Debugging Jira WebHooks",
    articleId: 74984,
    url: "https://help.piplanning.io/en/articles/74984-debugging-jira-webhooks",
    type: "article",
  },
  "alm-create-jira": {
    title: "Creating the ALM Connection to Jira",
    articleId: 74656,
    url: "https://help.piplanning.io/en/articles/74656-creating-the-alm-connection-to-jira",
    type: "article",
  },
  "alm-create-ado": {
    title: "Connect to Azure DevOps (ADO)",
    articleId: 235419,
    url: "https://help.piplanning.io/en/articles/235419-connect-to-azure-devops-ado",
    type: "article",
  },
  "alm-create-rally": {
    title: "Connect to Rally",
    articleId: 235466,
    url: "https://help.piplanning.io/en/articles/235466-connect-to-rally",
    type: "article",
  },
  "alm-team-mapping-jira": {
    title: "Jira Team Mapping",
    articleId: 42770,
    url: "https://help.piplanning.io/en/articles/42770-jira-team-mapping",
    type: "article",
  },
  "alm-team-mapping-ado": {
    title: "ADO ALM Connection > Team Mapping",
    articleId: 235448,
    url: "https://help.piplanning.io/en/articles/235448-ado-alm-connection-team-mapping",
    type: "article",
  },
  "alm-team-mapping-rally": {
    title: "Rally Team Mapping",
    articleId: 235471,
    url: "https://help.piplanning.io/en/articles/235471-rally-team-mapping",
    type: "article",
  },
  "alm-team-sync-jira": {
    title: "Jira Team Board Sync",
    articleId: 236449,
    url: "https://help.piplanning.io/en/articles/236449-jira-team-board-sync",
    type: "article",
  },
  "alm-team-sync-ado": {
    title: "ADO Team Board Sync",
    articleId: 235453,
    url: "https://help.piplanning.io/en/articles/235453-ado-team-board-sync",
    type: "article",
  },
  "alm-team-sync-rally": {
    title: "Rally Team Board Sync",
    articleId: 235476,
    url: "https://help.piplanning.io/en/articles/235476-rally-team-board-sync",
    type: "article",
  },
  "alm-art-mapping-jira": {
    title: "Jira ART Mapping",
    articleId: 235796,
    url: "https://help.piplanning.io/en/articles/235796-jira-art-mapping",
    type: "article",
  },
  "alm-art-mapping-ado": {
    title: "ADO ART Mapping",
    articleId: 235451,
    url: "https://help.piplanning.io/en/articles/235451-ado-art-mapping",
    type: "article",
  },
  "alm-art-mapping-rally": {
    title: "Rally ART Mapping",
    articleId: 235474,
    url: "https://help.piplanning.io/en/articles/235474-rally-art-mapping",
    type: "article",
  },
  "alm-art-field-mapping-team-jira": {
    title: "Jira - ART Backlog Board - Team field mapping",
    articleId: 128942,
    url: "https://help.piplanning.io/en/articles/128942-jira-art-backlog-board-team-field-mapping",
    type: "article",
  },
  "alm-art-field-mapping-art-jira": {
    title: "Jira - ART Backlog Board - ART field mapping",
    articleId: 236762,
    url: "https://help.piplanning.io/en/articles/236762-jira-art-backlog-board-art-field-mapping",
    type: "article",
  },

  // ── Identity Providers (SSO) ──────────────────────────────────────
  "sso-getting-started": {
    title: "Single Sign-On (SSO): Getting Started",
    articleId: 116709,
    url: "https://help.piplanning.io/en/articles/116709-single-sign-on-sso-getting-started",
    type: "article",
  },
  "sso-oidc": {
    title: "OpenID Connect (OIDC) Authentication",
    articleId: 108853,
    url: "https://help.piplanning.io/en/articles/108853-openid-connect-oidc-authentication",
    type: "article",
  },
  "sso-oidc-okta": {
    title: "SSO using Okta",
    articleId: 150983,
    url: "https://help.piplanning.io/en/articles/150983-sso-using-okta",
    type: "article",
  },
  "sso-oidc-entra": {
    title: "Microsoft Entra ID",
    articleId: 109245,
    url: "https://help.piplanning.io/en/articles/109245-microsoft-entra-id",
    type: "article",
  },
  "sso-oidc-google": {
    title: "Google (G Suite/Workspace) Integration",
    articleId: 109244,
    url: "https://help.piplanning.io/en/articles/109244-google-g-suite-workspace-integration",
    type: "article",
  },
  "sso-oidc-okta-groups": {
    title: "Enable Okta Group Reading",
    articleId: 109251,
    url: "https://help.piplanning.io/en/articles/109251-enable-okta-group-reading",
    type: "article",
  },
  "sso-oidc-group-mapping": {
    title: "Map IdP Groups to piplanning.io Teams",
    articleId: 109197,
    url: "https://help.piplanning.io/en/articles/109197-map-idp-groups-to-piplanning-io-teams",
    type: "article",
  },
  "sso-saml": {
    title: "SAML Configuration",
    articleId: 109268,
    url: "https://help.piplanning.io/en/articles/109268-saml-configuration",
    type: "article",
  },

  // ── Help Page ─────────────────────────────────────────────────────
  "help-troubleshooting": {
    title: "Performance or Latency Issues? Troubleshooting Guide",
    articleId: 174889,
    url: "https://help.piplanning.io/en/articles/174889-performance-or-latency-issues-troubleshooting-guide",
    type: "article",
  },
  "help-in-app-support": {
    title: "In-App Support (Messenger)",
    articleId: 75922,
    url: "https://help.piplanning.io/en/articles/75922-in-app-support-messenger",
    type: "article",
  },
  "help-self-service-portal": {
    title: "On-Premise Customers: Self-Service Portal",
    articleId: 75910,
    url: "https://help.piplanning.io/en/articles/75910-on-premise-customers-self-service-portal",
    type: "article",
  },
};
